import { integer, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { catalogItems } from "./catalog-item";

export const procurementOrderStatusEnum = pgEnum("procurement_order_status", [
  "PENDING_APPROVAL",
  "APPROVED",
  "SHIPPED",
  "INSPECTED",
  "COMPLETED",
  "CANCELLED",
]);

/**
 * @deprecated Boxed PO port. Unused at runtime; drop with procurement_requests.
 */
export const procurementOrders = pgTable("procurement_orders", {
  id: uuid("id").primaryKey().defaultRandom(),
  vendorId: uuid("vendor_id").notNull(),
  status: procurementOrderStatusEnum("status").notNull(),
  orderDate: timestamp("order_date", { withTimezone: true }).notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export const procurementOrderLines = pgTable("procurement_order_lines", {
  id: uuid("id").primaryKey().defaultRandom(),
  procurementOrderId: uuid("procurement_order_id")
    .notNull()
    .references(() => procurementOrders.id),
  itemId: uuid("item_id")
    .notNull()
    .references(() => catalogItems.id),
  quantityOrdered: integer("quantity_ordered").notNull(),
  unitCost: integer("unit_cost").notNull(),
  quantityReceived: integer("quantity_received"),
  conditionStatus: text("condition_status"),
  notes: text("notes"),
});
